import { reducerCreator } from '@adrias-online/steiner';
import { format, subMonths } from 'date-fns';

import helper from 'helpers/steinerHelper';
import { createHandlers } from 'helpers/hotelModuleHelper';
import { actionTypes } from '../actions/mailArchive';

const fromDate = format(subMonths(new Date(), 3), 'YYYY-MM-DD');
const endDate = format(new Date(), 'YYYY-MM-DD');

export const DEFAULT_STATE = helper.createDefaultState({
    list: {
        filters: {
            hotelId: null,
            source: null,
            from: fromDate,
            to: endDate
        }
    }
});

const handlers = createHandlers(actionTypes, {
    items: 'data.results',
    total: 'data.meta.total'
});

export default reducerCreator.createReducer(handlers, DEFAULT_STATE);

export const selectors = reducerCreator.createSelectors('mailArchive');
